var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Essentials/zoom/search",
    clipPath: "url(#clip0_650_6760)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.0762 15.2571C14.4023 15.5832 14.931 15.5832 15.2571 15.2571C15.5832 14.931 15.5832 14.4023 15.2571 14.0762L14.0762 15.2571ZM11.4787 6.82354C11.4787 9.39453 9.3945 11.4787 6.82351 11.4787V13.1487C10.3168 13.1487 13.1487 10.3168 13.1487 6.82354H11.4787ZM6.82351 11.4787C4.25252 11.4787 2.16831 9.39453 2.16831 6.82354H0.498313C0.498313 10.3168 3.3302 13.1487 6.82351 13.1487V11.4787ZM2.16831 6.82354C2.16831 4.25255 4.25252 2.16834 6.82351 2.16834V0.498344C3.3302 0.498344 0.498313 3.33023 0.498313 6.82354H2.16831ZM6.82351 2.16834C9.3945 2.16834 11.4787 4.25255 11.4787 6.82354H13.1487C13.1487 3.33023 10.3168 0.498344 6.82351 0.498344V2.16834ZM10.1546 11.3355L14.0762 15.2571L15.2571 14.0762L11.3355 10.1547L10.1546 11.3355Z",
    fill: "#858C95"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_650_6760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f30538acb435eeb567c40975a9a465c0.svg";
export { ForwardRef as ReactComponent };